import React, { Component } from 'react';
import ReactDOM from 'react-dom'

import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import { Link } from "react-router-dom";
import { dateDataTimeFormatter,dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';



  function buttonFormatter(cell, row,extra) {
    return (
      <div>
          <Link to={`/message/show/${cell}`} className="btn btn-default btn-sm"><i className="fa fa-eye"></i> نمایش </Link>
         
      </div>
    );
  }


class CertReqByPhysicianInMonth extends React.Component {
    
    constructor(props) {
        super(props);
       
        this.state = {
        
        
        };

       
      }
  
    render() { 
      const {list}=this.props;
      console.log('TABLE',list)
        return ( 
            <div>
                
                <BootstrapTable data={list && list}  striped hover
                    headerContainerClass='rightAlignStyle'
                    bodyContainerClass='rightAlignStyle'>
                    <TableHeaderColumn isKey dataField='Name' hidden >id</TableHeaderColumn>
                    <TableHeaderColumn dataField='Name' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}>پزشک</TableHeaderColumn>
                    <TableHeaderColumn dataField='Value'  thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} >تعداد گواهی</TableHeaderColumn>
                   
                </BootstrapTable>

                        
                  
            </div>
        
        );
    }
}

 
export default CertReqByPhysicianInMonth;